import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Response } from 'src/app/interfaces/response.interface';
import { LanguageCMS } from 'src/app/interfaces/language.interface';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public languages: string[] = ['en', 'es', 'de', 'it', 'ru'];
  private baseApiUrl = environment.baseApiUrl + '/protected/language';
  private baseApiUrl2 = environment.baseApiUrl + '/public/language';

  constructor(
    private httpClient: HttpClient,
    public translate: TranslateService, 
    private cookieService: CookieService
    ) { 
    let browserLang;
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/en|es|de|it|ru/) ? browserLang : 'en');
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

  async getLanguageByIdAsync(id: string): Promise<any> {
    return await this.httpClient.get<any>(`${this.baseApiUrl}/get-language-cms-by-id/${id}`).toPromise();
  }

  getLanguages(): Observable<Response> {
    return this.httpClient.get<Response>(`${this.baseApiUrl}/get-languages-cms`);
  }

  addLanguage(language: LanguageCMS): Observable<Response> {
    return this.httpClient.post<Response>(`${this.baseApiUrl}/add-language`, language);
  }

  updateLanguage(id: string, language: LanguageCMS): Observable<Response> {
    const url = `${this.baseApiUrl}/update-language/${id}`;
    return this.httpClient.put<Response>(url, language);
  }

  deleteLanguage(id: string): Observable<Response> {
    const url = `${this.baseApiUrl}/delete-by-id/${id}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.delete<Response>(url, { headers });
  }

  getMostrarMultilenguaje(): Observable<any> {
    return this.httpClient.get<any>(`${this.baseApiUrl2}/mostrar-multilenguaje`)
  }

  toggleMostrarMultilenguaje(): Observable<any> {
    return this.httpClient.put<Response>(`${this.baseApiUrl}/toggle-cambiar-multilenguaje`,{});
  }


}
